import { Component, Input } from '@angular/core';
import { AvaliacaoRequisitoVagaDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'form-avaliacao',
  templateUrl: './form-avaliacao.component.html',
  styleUrls: ['./form-avaliacao.component.scss'],
})
export class FormAvaliacaoComponent {
  @Input() perguntas: AvaliacaoRequisitoVagaDto[] = [];
  @Input() respostasSelecionadas: { avaliacaoRequisitoVagaId: string, respostaAvaliacaoRequisitoId: string }[] = [];
  @Input() disable = false;
  
  constructor() { }

  selecionarResposta(perguntaId: string, respostaId: string) {
    const index = this.respostasSelecionadas.findIndex(r => r.avaliacaoRequisitoVagaId === perguntaId);

    if (index > -1) {
      this.respostasSelecionadas[index].respostaAvaliacaoRequisitoId = respostaId;
    } else {
      this.respostasSelecionadas.push({
        avaliacaoRequisitoVagaId: perguntaId,
        respostaAvaliacaoRequisitoId: respostaId
      });
    }
  }

  isRespostaSelecionada(perguntaId: string, respostaId: string): boolean {
    return this.respostasSelecionadas.some(
      r => r.avaliacaoRequisitoVagaId === perguntaId && r.respostaAvaliacaoRequisitoId === respostaId
    );
  }
}
